import React, { Component } from 'react';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonCircleList from '../../../common-components/common-circle-list';

const list = [
    'видеоролик во всю ширину экрана дает наглядное представление о масштабе и специфики компании',
    'отдельными блоками отражены продукты и бренды, экспортная деятельность',
    'визуально сделали акцент на торговые марки и географию продаж',
    'добавили разделы «Новости» и «Карьера»',
];

class Design extends Component {
    render() {
        return (
            <div className="gapresource-design">
                <ScrollAnimation animateIn="fadeInUp" offset={100} animateOnce={true} duration={1}>
                    <div className="gapresource-design__wrapper">
                        <img
                            className="gapresource-design__img"
                            src="/images/pic/gapresource/gapresourceDesign.jpg"
                            alt="pill"
                            loading="lazy"
                        />
                        <img
                            className="gapresource-design__imgAbs"
                            src="/images/pic/gapresource/gapresourceDesignPh.jpg"
                            alt="pill"
                            loading="lazy"
                        />
                    </div>

                    <div className="gapresource-design__inner">
                        <CommonSmallTitle className="gapresource-design__subtitle">
                            Согласование визуальных концепций потребовало тесного взаимодействия с
                            несколькими бизнес-подразделениями заказчика. Чтобы учесть все
                            пожелания, реализовали блочное отображение основной информации о
                            компании:
                        </CommonSmallTitle>
                        <CommonCircleList
                            className="gapresource-design__list"
                            classNameInner="gapresource-design__list-inner"
                            CommonCircleList={{
                                list,
                                colorNumber: '#65B227',
                            }}
                        />
                    </div>
                </ScrollAnimation>
            </div>
        );
    }
}

export default Design;
